import React, { useState, useEffect } from 'react';
import './BannerForm.css';

const BannerForm = ({ open, onClose, onSubmit, initialData }) => {
    const [formData, setFormData] = useState({
        banner_url: '',
        banner_title: '',
        banner_subtitle: '',
        banner_action_url: ''
    });

    useEffect(() => {
        if (initialData) {
            setFormData({
                banner_url: initialData.banner_url || '',
                banner_title: initialData.banner_title || '',
                banner_subtitle: initialData.banner_subtitle || '',
                banner_action_url: initialData.banner_action_url || ''
            });
        } else {
            setFormData({
                banner_url: '',
                banner_title: '',
                banner_subtitle: '',
                banner_action_url: ''
            });
        }
    }, [initialData, open]);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Preparar dados do banner, removendo campos vazios
        const bannerData = {
            banner_url: formData.banner_url.trim(),
            ...(formData.banner_title.trim() && { banner_title: formData.banner_title.trim() }),
            ...(formData.banner_subtitle.trim() && { banner_subtitle: formData.banner_subtitle.trim() }),
            ...(formData.banner_action_url.trim() && { banner_action_url: formData.banner_action_url.trim() })
        };

        onSubmit(bannerData);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    if (!open) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{initialData ? 'Editar Banner' : 'Novo Banner'}</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                
                <form onSubmit={handleSubmit} className="form">
                    <div className="form-group">
                        <label htmlFor="banner_url">URL da Imagem *</label>
                        <input
                            type="url"
                            id="banner_url"
                            name="banner_url"
                            value={formData.banner_url}
                            onChange={handleChange}
                            required
                            placeholder="https://exemplo.com/imagem.jpg"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="banner_title">Título</label>
                        <input
                            type="text"
                            id="banner_title"
                            name="banner_title"
                            value={formData.banner_title}
                            onChange={handleChange}
                            placeholder="Título do banner"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="banner_subtitle">Subtítulo</label>
                        <input
                            type="text"
                            id="banner_subtitle"
                            name="banner_subtitle"
                            value={formData.banner_subtitle}
                            onChange={handleChange}
                            placeholder="Subtítulo do banner"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="banner_action_url">URL de Ação</label>
                        <input
                            type="url"
                            id="banner_action_url"
                            name="banner_action_url"
                            value={formData.banner_action_url}
                            onChange={handleChange}
                            placeholder="https://exemplo.com/acao"
                        />
                    </div>

                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="cancel-button">
                            Cancelar
                        </button>
                        <button type="submit" className="submit-button">
                            {initialData ? 'Atualizar' : 'Criar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BannerForm; 